var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '@hn-ui/tooltips';
import { css, styled } from 'styled-components';
import { Warning } from '@hn-ui/icons';
var TimeStruggleTooltip = function (_a) {
    var children = _a.children, weeklyTimeSpent = _a.weeklyTimeSpent, totalTimeSpent = _a.totalTimeSpent;
    return (_jsx(Tooltip, __assign({ maxWidth: 330, width: 'auto', content: getTimeSpentText(weeklyTimeSpent, totalTimeSpent) }, { children: children }), void 0));
};
var AccuracyStruggleTooltip = function (_a) {
    var children = _a.children, weeklyAccuracy = _a.weeklyAccuracy, totalAccuracy = _a.totalAccuracy;
    return (_jsx(Tooltip, __assign({ maxWidth: 330, width: 'auto', content: getAccuracyText(weeklyAccuracy, totalAccuracy) }, { children: children }), void 0));
};
var TimeAndAccuracyStruggleTooltip = function (_a) {
    var children = _a.children, weeklyAccuracy = _a.weeklyAccuracy, weeklyTimeSpent = _a.weeklyTimeSpent, totalAccuracy = _a.totalAccuracy, totalTimeSpent = _a.totalTimeSpent;
    return (_jsx(Tooltip, __assign({ maxWidth: 330, width: 'auto', content: getTimeSpentAndAccuracyText({
            weeklyAccuracy: weeklyAccuracy,
            weeklyTimeSpent: weeklyTimeSpent,
            totalTimeSpent: totalTimeSpent,
            totalAccuracy: totalAccuracy,
        }) }, { children: children }), void 0));
};
var StruggleTooltip = function (_a) {
    var children = _a.children, struggledAccuracy = _a.struggledAccuracy, struggledTime = _a.struggledTime, weeklyAccuracy = _a.weeklyAccuracy, weeklyTimeSpent = _a.weeklyTimeSpent, totalAccuracy = _a.totalAccuracy, totalTimeSpent = _a.totalTimeSpent;
    if (struggledAccuracy && struggledTime)
        return (_jsx(TimeAndAccuracyStruggleTooltip, __assign({ weeklyAccuracy: weeklyAccuracy, weeklyTimeSpent: weeklyTimeSpent, totalAccuracy: totalAccuracy, totalTimeSpent: totalTimeSpent }, { children: children }), void 0));
    if (struggledAccuracy)
        return (_jsx(AccuracyStruggleTooltip, __assign({ weeklyAccuracy: weeklyAccuracy, totalAccuracy: totalAccuracy }, { children: children }), void 0));
    if (struggledTime)
        return (_jsx(TimeStruggleTooltip, __assign({ weeklyTimeSpent: weeklyTimeSpent, totalTimeSpent: totalTimeSpent }, { children: children }), void 0));
    return _jsx(_Fragment, { children: children }, void 0);
};
var getTimeSpentText = function (weeklyTimeSpent, totalTimeSpent) {
    return "Too much time to\u00A0solve this task" + (typeof totalTimeSpent === 'number' &&
        typeof weeklyTimeSpent === 'number' &&
        weeklyTimeSpent !== totalTimeSpent
        ? "\n(" + totalTimeSpent + "\u00A0min\u00A0total)"
        : '');
};
var getAccuracyText = function (weeklyAccuracy, totalAccuracy) {
    return typeof totalAccuracy === 'number' &&
        typeof weeklyAccuracy === 'number' &&
        weeklyAccuracy !== totalAccuracy
        ? "Task accuracy is too\u00A0low (" + totalAccuracy + "%\u00A0overall)"
        : "Too many attempts to solve this task";
};
var getTimeSpentAndAccuracyText = function (_a) {
    var weeklyAccuracy = _a.weeklyAccuracy, weeklyTimeSpent = _a.weeklyTimeSpent, totalAccuracy = _a.totalAccuracy, totalTimeSpent = _a.totalTimeSpent;
    return totalTimeSpent === weeklyTimeSpent ||
        ([weeklyTimeSpent, totalTimeSpent].includes(undefined) &&
            [weeklyAccuracy, totalAccuracy].includes(undefined))
        ? "Too many attempts and too much time to\u00A0solve this task"
        : getTimeSpentText(weeklyTimeSpent, totalTimeSpent) + ". " + getAccuracyText(weeklyAccuracy, totalAccuracy);
};
var StruggleContainer = styled.div.withConfig({ displayName: "StruggleContainer", componentId: "sc-jkmerf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n"], ["\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n"])));
var StruggleCount = styled.sup.withConfig({ displayName: "StruggleCount", componentId: "sc-14urf43" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: -15px;\n  left: 17px;\n\n  font-style: normal;\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 20px;\n\n  ", ";\n"], ["\n  position: absolute;\n  top: -15px;\n  left: 17px;\n\n  font-style: normal;\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 20px;\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme, $seen = _a.$seen;
    return $seen
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          color: ", ";\n          opacity: 0.7;\n        "], ["\n          color: ", ";\n          opacity: 0.7;\n        "])), theme.colors.black60) : css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.colors.red50);
});
var StruggleIcon = function (_a) {
    var seen = _a.seen, struggledAccuracy = _a.struggledAccuracy, struggledTime = _a.struggledTime, weeklyAccuracy = _a.weeklyAccuracy, weeklyTimeSpent = _a.weeklyTimeSpent, totalAccuracy = _a.totalAccuracy, totalTimeSpent = _a.totalTimeSpent, _b = _a.size, size = _b === void 0 ? 20 : _b, count = _a.count, props = __rest(_a, ["seen", "struggledAccuracy", "struggledTime", "weeklyAccuracy", "weeklyTimeSpent", "totalAccuracy", "totalTimeSpent", "size", "count"]);
    return (_jsx(StruggleTooltip, __assign({ struggledAccuracy: struggledAccuracy, struggledTime: struggledTime, totalAccuracy: totalAccuracy, totalTimeSpent: totalTimeSpent, weeklyAccuracy: weeklyAccuracy, weeklyTimeSpent: weeklyTimeSpent }, { children: _jsxs(StruggleContainer, __assign({}, props, { children: [_jsx(Warning, { size: size, color: seen ? 'black60' : 'red50' }, void 0), typeof count === 'number' && (_jsx(StruggleCount, __assign({ "$seen": seen, "data-testid": 'struggle-count' }, { children: count }), void 0))] }), void 0) }), void 0));
};
export { StruggleIcon, StruggleTooltip };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
